import { Container, Graphics } from 'pixi.js';
import type { BuildingId } from '@data/buildings';

/** Small, bounded pixel accents; positions never alter the building footprint. */
export function animateStructure(root:Container,id:BuildingId|'keep',age:number,frame:number):void {
  let fx=root.getChildByLabel('age-accent') as Graphics | null;
  if(!fx){fx=new Graphics();fx.label='age-accent';root.addChild(fx);}
  fx.clear();
  const phase=frame%4;
  if(age<4) {
    if(id==='keep'||id==='barracks') {
      const x=id==='keep'?-38:30,y=-46;
      fx.rect(x,y,2,24).fill(0x7a4e2a);
      for(let i=0;i<6;i++)fx.rect(x+2+i*2,y+((i+phase)%4<2?0:2),2,10).fill(i<3?0x3fa7c4:0x1f6e86);
    }
    if(id==='lumberCamp'&&age>=2) {
      fx.rect(18,-12,16,14).fill(0x4f3a26);
      for(let i=0;i<4;i++){const a=(i+phase*.25)*Math.PI/2;fx.rect(24+Math.round(Math.cos(a)*5)*2,-7+Math.round(Math.sin(a)*3)*2,4,4).fill(0xd1a56e);}
    }
  } else if(age===4) {
    if(id==='lumberCamp'||id==='mine'||id==='quarry'){
      fx.rect(10,-13,10,8).fill(0x4a4f5a);fx.rect(12+phase*2,-11,2,4).fill(0xa8b0b8);
    }
  } else if(age>=7) {
    const x=0,y=-40;
    // Each architectural grammar carries its own restrained motion.
    if(age===7){
      const a=frame*Math.PI/12;fx.rect(Math.round(Math.cos(a)*17)*2,y+Math.round(Math.sin(a)*5)*2,2,2).fill(0xffe29a);
      fx.rect(-16+phase*8,6,3,2).fill(0xe8b34a);
    }else if(age===8){
      for(let i=0;i<3;i++)fx.rect(-10+i*6,-14-((frame+i*3)%10)*2,2,2).fill(0x7fd4dc);
    }else if(age===9){
      const a=frame*Math.PI/8;
      fx.rect(Math.round(Math.cos(a)*12)*2,-3+Math.round(Math.sin(a)*3)*2,3,2).fill(0xc79bff);
      if(root.children[0])root.children[0].y=10.88+Math.round(Math.sin(frame*Math.PI/16)*2);
    }else if(age===10){
      const spread=phase*6;fx.rect(x-spread,y+spread/2,2,2).fill(0xfff8e6);fx.rect(x+spread,y+spread/2,2,2).fill(0x7fd4dc);
    }else{
      const a=frame*Math.PI/16;
      fx.rect(Math.round(Math.cos(a)*12)*2,y+Math.round(Math.sin(a)*14)*2,2,2).fill(0xfff8e6);
      fx.rect(-Math.round(Math.cos(a)*12)*2,y-Math.round(Math.sin(a)*14)*2,2,2).fill(0xe8b34a);
    }
  } else {
    const color=age>=9?0xc79bff:0x7fd4dc;
    fx.rect(-25+phase*2,6,4,2).fill(color);fx.rect(23-phase*2,4,2,2).fill(color);
    if(id==='school') {
      const a=frame*Math.PI/8;
      fx.rect(Math.round(Math.cos(a)*10)*2,-42+Math.round(Math.sin(a)*3)*2,4,2).fill(color);
    }
    if(id==='quarry'||id==='mine')fx.rect(id==='quarry'?10:0,-20+phase*4,2,8).fill({color,alpha:.8});
    if(id==='keep'&&age>=7) {
      const a=frame*Math.PI/8;
      fx.rect(Math.round(Math.cos(a)*17)*2,-48+Math.round(Math.sin(a)*5)*2,4,4).fill(color);
    }
  }
}

